import { Splash } from 'core/styles/Banner'
import React from 'react'
import * as Sentry from '@sentry/nextjs'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'
import { lighter } from '../helpers/color'
import { breakpoint } from '../layout/styles'
import { Container } from '../styles/Container'
import { Grid, Cell } from '../styles/Grid'
import ReactHtmlParser from 'react-html-parser'


const Contact = ({ data, translations }: any) => {
  const { register, formState, formState: { errors } } = useForm({ mode: 'onChange' })
  const [submitted, setSubmitted] = React.useState(false)
  async function handleOnSubmit(e: any) {
    e.preventDefault();
    const formData: any = {};

    Array.from(e.currentTarget.elements).forEach((field: any) => {
      if (!field.name) return;
      let value = field.value
      if (field.name === 'subject')
        value = `${document.title} - ${value}`
      formData[field.name] = value;
    })

    setSubmitted(true)

    await fetch('/api/mail', {
      method: 'POST',
      body: JSON.stringify(formData)
    }).catch((error: any) => {
      console.error(error)
      Sentry.captureException(error)
    })
  }

  if(submitted)
    return (
      <Wrapper>
        <SectionTitle>{data.title}</SectionTitle>
        {data.thanks && <div style={{ minHeight: '40vh' }}>{ReactHtmlParser(data.thanks)}</div>}
      </Wrapper>
    )

  return (
    <Wrapper>
      <SectionTitle>{data.title}</SectionTitle>
      <form method="POST" onSubmit={handleOnSubmit} encType="multipart/form-data">
        <input type="hidden" name="from" value={data.email} />
        <input type="hidden" name="to" value={data.email_to} />
        <FormRow>
          <FormField style={{ width: '33.3333%' }}>
            <label>{translations.first_name}<br />
              <input
                type="text"
                {...register("firstname")} />
            </label>
          </FormField>
          <FormField style={{ width: '33.3333%' }}>
            <label>{translations.last_name}<Mandatory>*</Mandatory><br />
              <input
                type="text"
                {...register("lastname", { required: true })} />
            </label>
          </FormField>
          <FormField style={{ width: '33.3333%' }}>
            <label>{translations.email}<br />
              <input
                type="text"
                {...register("email", {
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    message: 'Invalid email'
                  }
                })} />
            </label>
          </FormField>
        </FormRow>
        <FormRow>
          <FormField>
            <label>Subject<Mandatory>*</Mandatory><br />
              <input
                type="text"
                {...register("subject", { required: true })} />
            </label>
          </FormField>
        </FormRow>
        <FormRow>
          <FormField>
            <label>{translations.message}<br />
              <textarea
                rows={6}
                {...register("message")}></textarea>
            </label>
          </FormField>
        </FormRow>
        <FormRow>
          <FormField>
            <label>{translations.phone_number}<br />
              <input
                type="text"
                {...register("phoneNumber", {
                  pattern: {
                    value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/i,
                    message: 'Invalid phone number'
                  }
                })} />
            </label>
          </FormField>
          <FormField style={{ width: '66.6666%' }}>
            <label>{translations.address}<br />
              <input
                type="text"
                {...register("address")} />
            </label>
          </FormField>
        </FormRow>
        <FormRow>
          <FormField style={{ width: '33.3333%' }}>
            <label>{translations.city}<br />
              <input
                type="text"
                {...register("city")} />
            </label>
          </FormField>
          <FormField style={{ width: '33.3333%' }}>
            <label>{translations.state}<br />
              <input
                type="text"
                {...register("state")} />
            </label>
          </FormField>
          <FormField style={{ width: '33.3333%' }}>
            <label>{translations.zip}<br />
              <input
                type="text"
                {...register("zip")} />
            </label>
          </FormField>
        </FormRow>
        {/* <FormRow>
          <FormField>
            <label>Attachment<br />
              <input
                type="file"
                {...register("file")} />
            </label>
          </FormField>
        </FormRow> */}
        <FormRow>
          <FormField>
            <input type="submit" disabled={!formState.isValid} value={translations.send_button} />
          </FormField>
        </FormRow>
      </form>
      {/* 
    USA sites routes (Sea Cuisine) to feedback@highlinerfoodsUSA.com 
Canadian sites route (High Liner) to feedback@higliner.com
 
Fields (* required)
First Name
Last Name*
Email
Subject line* This could be helpful if it was programmed to include the brand automatically, that way if a consumer leaves out specific product info we at least have that
Message

Additional Fields
Phone Number
Address
City
State
Zip
 
File attach*

    */}
    </Wrapper>
  )
}

export default Contact

const Wrapper = styled(Container)`
  color: var(--text);
  margin: 36px 20px;
  background: ${props => props.background || 'none'};
  padding: 20px;
  @media ${breakpoint.desktop} {
    margin: 100px auto 48px;
    padding: 0;
    background: none;
  }
`

const FormRow = styled(Grid)`
  max-width: 560px;
  margin: 0 auto;
`

const Mandatory = styled.span`
  color: red;
`

const FormField = styled(Cell)`
  padding: 0.25rem 0.5rem;
  margin: 0.25rem 0 0.5rem;
  input[type=text],
  input[type=email],
  input[type=file],
  textarea {
    padding: 0.25rem;
    font-family: 'Open Sans',-apple-system,BlinkMacSystemFont,'Helvetica Neue',Segoe UI,sans-serif;
    width: 100%;
    border: 1.333px solid #444444;
    border-radius: 2.5px;
    margin-top: 0.25rem;
    &:hover {
      border-color: #002D72;
    }
  }
  
  input[type=submit] {
    border: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 11px 20px;
    background: var(--button-bg, var(--primary));
    color: white;
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.05em;
    text-align: center;
    text-transform: uppercase;
    cursor: pointer;
    &:disabled {
      background: #EAEAEA;
      color: rgba(102, 102, 102, 1);
    }
    &:hover {
      background: var(--primary);
    }
  }

  label {
    display: block;
    font-size: 14px;
  }
`

const SectionTitle = styled.h3`
  margin: 16px 0;
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  @media ${breakpoint.desktop} {
    margin: 48px 0 24px 0;
    font-size: 36px;
  }
`